import apis from '#store/api';
import { Location } from "#root/queries/locations";
import { useQuery } from "@tanstack/react-query";
import { DataApiResponse, DataCollectionApiResponse } from './types';
import { Person } from './persons';

export const MAP_KEY = 'map';
export const MAP_QUERY_KEYS = {
  STATISTICS: 'statistics',
  LOCATIONS: 'locations',
  VICTIMS: 'victims'
} as const;

export interface MapStatistics {
    totalVictims: number;
    totalPublic: number;
    totalMatched: number;
    totalConnected: number;
}

export interface MapLocation {
    location: Location;
    coordinates: Coordinates;
    statistics: MapStatistics;
    isIncident: boolean;
}

interface Coordinates {
    latitude: number;
    longitude: number;
}

interface GetMapLocationsParams {
    incidentId?: string;
}

interface GetMapStatisticsParams {
    incidentId?: string;
}

interface GetMapVictimsParams {
    locationId: string;
    incidentId?: string;
    isIncident: boolean;
}

// Fetch maps locations list
export const useMapLocations = (params: GetMapLocationsParams) => {
    return useQuery({
        queryKey: [MAP_KEY, MAP_QUERY_KEYS.LOCATIONS, params],
        queryFn: async () => {
            const response = await apis.map.getMapLocations({ params });
            return response.data as DataCollectionApiResponse<MapLocation>;
        },
    });
};

// Fetch map statistics
export const useMapStatistics = (params: GetMapStatisticsParams) => {
    return useQuery({
        queryKey: [MAP_KEY, MAP_QUERY_KEYS.STATISTICS, params],
        queryFn: async () => {
            const response = await apis.map.getMapStatistics({ params });
            return response.data as DataApiResponse<MapStatistics>;
        },
    });
};

// Fetch maps victims list
export const useMapVictims = (params: GetMapVictimsParams, options?: { enabled?: boolean }) => {
    return useQuery({
        queryKey: [MAP_KEY, MAP_QUERY_KEYS.VICTIMS, params],
        queryFn: async () => {
            const response = await apis.map.getMapVictims({ params });
            return response.data as DataCollectionApiResponse<Person>;
        },
        ...options
    });
};